module.exports = __webpack_public_path__ + "static/media/getthebox@3x.dd7642b3.png";